import LoginContainer from './LoginContainer';

export {
  LoginContainer
};

export default LoginContainer;
